<form *ngIf="showAuslandsAdresse" [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div class="form-row">
    <label class="d-sm-none col-form-label"
           for="auslandsadresseStrasse{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.STRASSE' | translate }}</label>
    <label class="d-none d-sm-inline col-sm-4 col-form-label">
      {{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.STR_HNR_ZUS' | translate }}
    </label>
    <div class="col-sm-4">
      <input class="form-control" datevMessagePath="auslandsadresseStrasse{{objectId}}" formControlName="strasse" id="auslandsadresseStrasse{{index}}"
             type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none col-form-label"
           for="auslandsadresseHausnummer{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.HAUSNUMMER' | translate }}</label>
    <div class="col-sm-2">
      <input class="form-control" datevMessagePath="auslandsadresseHausnummer{{objectId}}" formControlName="hausnummer" id="auslandsadresseHausnummer{{index}}"
             type="text" numeric utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none col-form-label"
           for="auslandsadresseHausnummernzusatz{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.HAUSNUMMERNZUSATZ' | translate }}</label>
    <div class="col-sm-2">
      <input class="form-control" datevMessagePath="auslandsadresseHausnummernzusatz{{objectId}}" formControlName="hausnummernzusatz"
             id="auslandsadresseHausnummernzusatz{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="auslandsadresseAdressergaenzung{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.ADRESSERGAENZUNG' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="auslandsadresseAdressergaenzung{{objectId}}" formControlName="adressergaenzung"
             id="auslandsadresseAdressergaenzung{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row">
    <label class="d-sm-none col-form-label"
           for="auslandsadressePostleitzahl{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.PLZ' | translate }}</label>
    <label class="d-none d-sm-inline col-sm-4 col-form-label">
      {{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.PLZ_ORT' | translate }}
    </label>
    <div class="col-sm-2">
      <input class="form-control" datevMessagePath="auslandsadressePostleitzahl{{objectId}}" formControlName="postleitzahl" id="auslandsadressePostleitzahl{{index}}"
             type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none col-form-label"
           for="auslandsadresseOrt{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.ORT' | translate }}</label>
    <div class="col-sm-6">
      <input class="form-control" datevMessagePath="auslandsadresseOrt{{objectId}}" formControlName="ort" id="auslandsadresseOrt{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="auslandsadresseLand{{index}}">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.LABEL' | translate }}</label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="auslandsadresseLand{{objectId}}" formControlName="land" id="auslandsadresseLand{{index}}"
              utilsCheckValidity utilsControlState utilsMarkRequired
              utilsValidationMessage>
        <option [ngValue]="null" selected>{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(laenderschluesselEnum)"
                [ngValue]="laenderschluesselEnum[value]">{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.KEY_' + laenderschluesselEnum[value] | translate }}
        </option>
      </select>
    </div>
  </div>

</form>
